// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"az_pYb","infoLabel":"az_qYb"};